"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.oldToNewComponentValueMap = exports.v1ComponentsSerializationMap = void 0;
const common_utils_1 = require("./utils/common-utils");
const informative_utils_1 = require("./utils/informative-utils");
const v1ComponentsSerializationMap = ($) => ({
    text: {
        htmlNodeToValue: ($node) => ({
            html: $node.parent().html() || '',
        }),
        valueToHtml: (value) => value.html.replace(/<\s*p[^>]*>([^<]*)<\s*\/\s*p\s*>/g, (str) => str.replace(/	/g, ' &nbsp;')),
    },
    tip: {
        htmlNodeToValue: ($node) => ({
            html: $('<div>').append($node).html(),
        }),
        valueToHtml: (value) => value.html,
    },
    important: {
        htmlNodeToValue: ($node) => ({
            html: $('<div>').append($node).html(),
        }),
        valueToHtml: (value) => value.html,
    },
    line: {
        htmlNodeToValue: () => ({}),
        valueToHtml: () => '<hr />',
    },
    subheading: {
        htmlNodeToValue: ($node) => ({ text: $node.text() }),
        valueToHtml: (value) => `<h3>${value.text}</h3>`,
    },
    note: {
        htmlNodeToValue: ($node) => ({
            html: $('<div>').append($node).html(),
            type: 'note',
        }),
        valueToHtml: (value) => value.html,
    },
    image: {
        htmlNodeToValue: ($node) => {
            const $img = $node.is('img') ? $node : $node.find('img');
            const $container = $node.is('.img-container') ? $node : $node.find('.img-container');
            const $link = $node.find('a');
            return {
                src: $img.attr('src'),
                alt: $img.attr('alt') || '',
                link: $link.attr('href') || '',
                align: $container.css('text-align') || 'left',
            };
        },
        valueToHtml: (value) => {
            const imageHtml = `<img src="${value.src}" ${value.alt ? 'alt="' + value.alt + '"' : ''}/>`;
            const innerHtml = value.link ? `<a href="${value.link}">${imageHtml}</a>` : imageHtml;
            return `<div class="img-container" style="text-align:${value.align}">${innerHtml}</div>`;
        },
    },
    iframe: {
        htmlNodeToValue: ($node) => {
            const $iframe = $node.find('iframe');
            const width = $iframe.css('width').indexOf('%') === -1 ? parseInt($iframe.css('width'), 10) : null;
            const height = $iframe.css('height').indexOf('%') === -1 ? parseInt($iframe.css('height'), 10) : null;
            return {
                url: $iframe.attr('src'),
                width,
                height,
                align: $node.css('text-align'),
                scrolling: $iframe.attr('scrolling') || 'auto',
            };
        },
        valueToHtml: (value) => {
            const width = value.width ? value.width + 'px' : '100%';
            const height = value.height ? value.height + 'px' : '100%';
            return `<div style="text-align:${value.align}"><iframe src="${value.url}" style="width:${width};height:${height};" scrolling="${value.scrolling}"/></div>`;
        },
    },
    video: {
        htmlNodeToValue: ($node) => {
            const $iframe = $node.find('iframe');
            const width = $iframe.css('width').indexOf('%') === -1 ? parseInt($iframe.css('width'), 10) : null;
            const height = $iframe.css('height').indexOf('%') === -1 ? parseInt($iframe.css('height'), 10) : null;
            return {
                url: $iframe.attr('src'),
                width,
                height,
                align: $node.css('text-align'),
            };
        },
        valueToHtml: (value) => {
            const width = value.width ? value.width + 'px' : '100%';
            const height = value.height ? value.height + 'px' : '100%';
            return `<div style="text-align:${value.align}"><iframe src="${value.url}" style="width:${width};height:${height};"></iframe></div>`;
        },
    },
    anchor: {
        htmlNodeToValue: ($node) => ({ text: $node.text(), id: $node.attr('id') || '' }),
        valueToHtml: (value) => {
            const id = value.id || '';
            return `<h2 class="anchor-title" id="${id}">${value.text}</h2>`;
        },
    },
    code: {
        htmlNodeToValue: ($node) => ({
            language: $node.attr('data-language'),
            lineNumbers: !!$node.attr('data-line-numbers'),
            lineWrapping: !!$node.attr('data-line-wrapping'),
            code: $node.find('code').text(),
        }),
        valueToHtml: (value) => `<div class="code-snippet" data-language="${value.language}" data-line-numbers="${value.lineNumbers}" data-line-wrapping="${value.lineWrapping}"><pre><code>${value.code}</code></pre></div>`,
    },
    table: {
        htmlNodeToValue: ($node) => ({
            rows: $node.find('tbody tr').length,
            columns: $node.find('th').length,
            headings: $node.find('th').toArray().map((elm) => $(elm).text()),
            cells: $node
                .find('tbody tr')
                .toArray()
                .map((tr) => $(tr)
                .find('td')
                .toArray()
                .map((td) => $(td).html())),
        }),
        valueToHtml: (value) => {
            let headContent = '';
            let bodyContent = '';
            for (let col = 0; col < value.columns; col++) {
                headContent += `<th>${value.headings[col]}</th>`;
            }
            for (let row = 0; row < value.rows; row++) {
                bodyContent += '<tr>';
                for (let col = 0; col < value.columns; col++) {
                    bodyContent += `<td>${value.cells[row] && value.cells[row][col] ? value.cells[row][col] : ''}</td>`;
                }
                bodyContent += '</tr>';
            }
            return `<table><thead><tr>${headContent}</tr><tbody>${bodyContent}</tbody></table>`;
        },
    },
    'step-by-step': {
        htmlNodeToValue: ($node) => ({
            layout: $node.attr('data-layout') || 'newspaper',
            allowCircular: $node.attr('data-allow-circular') === 'true',
            steps: $node
                .find('.step')
                .toArray()
                .map((step) => {
                const $step = $(step);
                return {
                    html: $step.find('.step-description').html(),
                    imageSrc: $step.find('.step-image').attr('src'),
                };
            }),
        }),
        valueToHtml: (stepsValue) => {
            const stepsHtml = stepsValue.steps
                .map((step) => `<section class="step"><img class="step-image" src="${step.imageSrc}" /><div class="step-description">${step.html}</div></section>`)
                .join('');
            const layout = stepsValue.layout || 'newspaper';
            return `<div class="step-by-step-container" data-layout="${layout}" data-allow-circular="${stepsValue.allowCircular}">${stepsHtml}</div>`;
        },
    },
});
exports.v1ComponentsSerializationMap = v1ComponentsSerializationMap;
const oldToNewComponentValueMap = (locale, $) => ({
    text: (oldValue) => ({
        type: 'text',
        value: { html: (0, common_utils_1.removeExtraSpaces)(oldValue.html, $) },
    }),
    tip: (oldValue) => ({
        type: 'informative',
        value: {
            color: 'green',
            title: (0, informative_utils_1.informativeTypeToTitle)('tip', locale),
            html: (0, common_utils_1.removeRedundantBoldTextAndSpacing)(oldValue.html, $),
        },
    }),
    important: (oldValue) => ({
        type: 'informative',
        value: {
            color: 'orange',
            title: (0, informative_utils_1.informativeTypeToTitle)('important', locale),
            html: (0, common_utils_1.removeRedundantBoldTextAndSpacing)(oldValue.html, $),
        },
    }),
    line: () => ({
        type: 'line',
        value: { style: 'thin' },
    }),
    subheading: (oldValue) => ({
        type: 'heading',
        value: { text: oldValue.text, anchorId: '' },
    }),
    note: (oldValue) => ({
        type: 'text',
        value: { html: (0, common_utils_1.removeExtraSpaces)(oldValue.html, $) },
    }),
    image: (oldValue) => ({ type: 'image', value: oldValue }),
    iframe: (oldValue) => ({
        type: 'iframe',
        value: {
            url: oldValue.url,
            width: 600,
            height: 400,
            align: 'center',
            scrolling: oldValue.scrolling,
        },
    }),
    video: (oldValue) => ({
        type: 'video',
        value: {
            url: oldValue.url,
            width: oldValue.width,
            height: oldValue.height,
            align: 'center',
        },
    }),
    table: (oldValue) => ({ type: 'table', value: oldValue }),
    code: (oldValue) => ({
        type: 'code',
        value: {
            language: oldValue.language,
            code: oldValue.code,
            lineNumbers: true,
            lineWrapping: true,
        },
    }),
    anchor: (oldValue) => ({
        type: 'heading',
        value: { text: oldValue.text, anchorId: oldValue.id },
    }),
    'step-by-step': (oldValue) => ({
        type: 'step-by-step',
        value: {
            allowCircular: oldValue.allowCircular,
            layout: 'vertical',
            steps: oldValue.steps.map((oldStep) => ({
                html: oldStep.html,
                title: '',
                image: { src: oldStep.imageSrc, alt: '', link: '' },
            })),
        },
    }),
});
exports.oldToNewComponentValueMap = oldToNewComponentValueMap;
